import React, { useId } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { CatalogItem, SerializedKit } from '../../../../redux/api/fymAPI.types';
import { SMLButton } from '../../components/primitives/SMLButton';
import { ThemePanel } from '../releases/theme/ThemePanel';
import { themeMessages } from '../releases/theme/themeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the theme chip and its dialog */
import styles from './StudioTheme.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StudioThemeDialogProps {
  isOpen: boolean;
  accountId: number;
  item: CatalogItem;
  kit: SerializedKit | null;
  onClose: () => void;
}

/**
 * "Change" of the Studio theme chip (design q3a, q4): the Theme panel of the song page in a dialog,
 * below 576 px a bottom sheet. It is the same `PATCH .../look` as on the song page, so the song
 * keeps one theme, and the hint says "Changes apply to this song."
 */
const StudioThemeDialogComponent: React.FC<StudioThemeDialogProps> = ({ isOpen, accountId, item, kit, onClose }) => {
  const intl = useIntl();
  const titleId = useId();
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      size="xl"
      labelledBy={titleId}
      className={styles.dialog}
      contentClassName={styles.content}
      returnFocusAfterClose
    >
      <div className={styles.sheet} data-testid="studio-theme-dialog">
        <span className={styles.grab} aria-hidden="true" />
        <h2 id={titleId} className="visually-hidden">
          {intl.formatMessage(themeMessages.dialogTitle, { title: item.title })}
        </h2>
        <ThemePanel
          accountId={accountId}
          item={item}
          kit={kit}
          hint={intl.formatMessage(themeMessages.studioHint)}
          isInDialog
        />
        <div className={styles.footer}>
          <SMLButton variant="primary" onClick={onClose}>
            {intl.formatMessage(themeMessages.dialogDone)}
          </SMLButton>
        </div>
      </div>
    </Modal>
  );
};

export const StudioThemeDialog = TypedMemo(StudioThemeDialogComponent);
